import { gsap } from 'gsap';
import { checkDeviceType, devices } from '../utils/checkDeviceType';
const components: NodeListOf<Element> = document.querySelectorAll('.link-block');

export class LinkBlock {
  constructor() {
    if (checkDeviceType() === devices.desktop) {
      components.forEach((component) => {
        this.loadImage(component as HTMLElement);
      });
    }
  }

  loadImage(component: HTMLElement) {
    const backgroundImageContainer = component.querySelector('.link-block-image') as HTMLElement;
    const imageUrl = backgroundImageContainer?.dataset.backgroundImage;

    if (imageUrl) {
      let preloadImage: HTMLImageElement | null = document.createElement('img');
      if (preloadImage) {
        preloadImage.src = imageUrl;
        preloadImage.addEventListener('load', (event) => {
          component.classList.add('show');
          backgroundImageContainer.style.backgroundImage = `linear-gradient(275deg, rgba(0,0,0,0) 20%, rgba(0,0,0,0.3) 50%),url(${imageUrl})`;
          preloadImage = null;
        });
      }
    } else {
      component?.classList.add('show');
    }
  }

  show(component: HTMLElement) {}
}
